// app/src/dashboard/marketHolidays.ts

export type MarketId = 'US' | 'EU' | 'FR';

export interface MarketHoliday {
  date: string; // "YYYY-MM-DD"
  label: string; // Human-readable name
  market: MarketId;
}

export const MARKET_HOLIDAYS: MarketHoliday[] = [
  // ── 2025 US (NYSE) ──────────────────────────────────────────────
  { date: '2025-01-01', label: "New Year's Day", market: 'US' },
  { date: '2025-01-20', label: 'Martin Luther King Jr. Day', market: 'US' },
  { date: '2025-02-17', label: "Presidents' Day", market: 'US' },
  { date: '2025-04-18', label: 'Good Friday', market: 'US' },
  { date: '2025-05-26', label: 'Memorial Day', market: 'US' },
  { date: '2025-06-19', label: 'Juneteenth National Independence Day', market: 'US' },
  { date: '2025-07-04', label: 'Independence Day', market: 'US' },
  { date: '2025-09-01', label: 'Labor Day', market: 'US' },
  { date: '2025-11-27', label: 'Thanksgiving Day', market: 'US' },
  { date: '2025-12-25', label: 'Christmas Day', market: 'US' },

  // ── 2025 EU (Euronext Paris) ─────────────────────────────────────
  { date: '2025-01-01', label: "New Year's Day", market: 'EU' },
  { date: '2025-04-18', label: 'Good Friday', market: 'EU' },
  { date: '2025-04-21', label: 'Easter Monday', market: 'EU' },
  { date: '2025-05-01', label: 'Labour Day', market: 'EU' },
  { date: '2025-12-25', label: 'Christmas Day', market: 'EU' },
  { date: '2025-12-26', label: 'Boxing Day', market: 'EU' },

  // ── 2025 FR (jours fériés français exclusifs) ────────────────────
  { date: '2025-05-08', label: 'Victory in Europe Day', market: 'FR' },
  { date: '2025-05-29', label: 'Ascension Day', market: 'FR' },
  { date: '2025-06-09', label: 'Whit Monday', market: 'FR' },
  { date: '2025-07-14', label: 'Bastille Day', market: 'FR' },
  { date: '2025-08-15', label: 'Assumption of Mary', market: 'FR' },
  { date: '2025-11-01', label: "All Saints' Day", market: 'FR' },
  { date: '2025-11-11', label: 'Armistice Day', market: 'FR' },

  // ── 2026 US (NYSE) ──────────────────────────────────────────────
  { date: '2026-01-01', label: "New Year's Day", market: 'US' },
  { date: '2026-01-19', label: 'Martin Luther King Jr. Day', market: 'US' },
  { date: '2026-02-16', label: "Presidents' Day", market: 'US' },
  { date: '2026-04-03', label: 'Good Friday', market: 'US' },
  { date: '2026-05-25', label: 'Memorial Day', market: 'US' },
  { date: '2026-06-19', label: 'Juneteenth National Independence Day', market: 'US' },
  { date: '2026-07-03', label: 'Independence Day (observed)', market: 'US' },
  { date: '2026-09-07', label: 'Labor Day', market: 'US' },
  { date: '2026-11-26', label: 'Thanksgiving Day', market: 'US' },
  { date: '2026-12-25', label: 'Christmas Day', market: 'US' },

  // ── 2026 EU (Euronext Paris) ─────────────────────────────────────
  { date: '2026-01-01', label: "New Year's Day", market: 'EU' },
  { date: '2026-04-03', label: 'Good Friday', market: 'EU' },
  { date: '2026-04-06', label: 'Easter Monday', market: 'EU' },
  { date: '2026-05-01', label: 'Labour Day', market: 'EU' },
  { date: '2026-12-25', label: 'Christmas Day', market: 'EU' },
  { date: '2026-12-26', label: 'Boxing Day', market: 'EU' },

  // ── 2026 FR (jours fériés français exclusifs) ────────────────────
  { date: '2026-05-08', label: 'Victory in Europe Day', market: 'FR' },
  { date: '2026-05-14', label: 'Ascension Day', market: 'FR' },
  { date: '2026-05-25', label: 'Whit Monday', market: 'FR' },
  { date: '2026-07-14', label: 'Bastille Day', market: 'FR' },
  { date: '2026-08-15', label: 'Assumption of Mary', market: 'FR' },
  { date: '2026-11-01', label: "All Saints' Day", market: 'FR' },
  { date: '2026-11-11', label: 'Armistice Day', market: 'FR' },

  // ── 2027 US (NYSE) ──────────────────────────────────────────────
  { date: '2027-01-01', label: "New Year's Day", market: 'US' },
  { date: '2027-01-18', label: 'Martin Luther King Jr. Day', market: 'US' },
  { date: '2027-02-15', label: "Presidents' Day", market: 'US' },
  { date: '2027-03-26', label: 'Good Friday', market: 'US' },
  { date: '2027-05-31', label: 'Memorial Day', market: 'US' },
  { date: '2027-06-19', label: 'Juneteenth National Independence Day', market: 'US' },
  { date: '2027-07-05', label: 'Independence Day (observed)', market: 'US' },
  { date: '2027-09-06', label: 'Labor Day', market: 'US' },
  { date: '2027-11-25', label: 'Thanksgiving Day', market: 'US' },
  { date: '2027-12-24', label: 'Christmas Day (observed)', market: 'US' },

  // ── 2027 EU (Euronext Paris) ─────────────────────────────────────
  { date: '2027-01-01', label: "New Year's Day", market: 'EU' },
  { date: '2027-03-26', label: 'Good Friday', market: 'EU' },
  { date: '2027-03-29', label: 'Easter Monday', market: 'EU' },
  { date: '2027-05-01', label: 'Labour Day', market: 'EU' },
  { date: '2027-12-24', label: 'Christmas Day (observed)', market: 'EU' },
  { date: '2027-12-27', label: 'Boxing Day (observed)', market: 'EU' },

  // ── 2027 FR (jours fériés français exclusifs) ────────────────────
  { date: '2027-05-06', label: 'Ascension Day', market: 'FR' },
  { date: '2027-05-08', label: 'Victory in Europe Day', market: 'FR' },
  { date: '2027-05-17', label: 'Whit Monday', market: 'FR' },
  { date: '2027-07-14', label: 'Bastille Day', market: 'FR' },
  { date: '2027-08-15', label: 'Assumption of Mary', market: 'FR' },
  { date: '2027-11-01', label: "All Saints' Day", market: 'FR' },
  { date: '2027-11-11', label: 'Armistice Day', market: 'FR' },
];

/**
 * Returns a Map keyed by "YYYY-MM-DD" → array of holidays on that date.
 * Built once at module load time for O(1) lookup in the calendar.
 */
export const HOLIDAYS_BY_DATE: Map<string, MarketHoliday[]> = new Map();
for (const holiday of MARKET_HOLIDAYS) {
  const existing = HOLIDAYS_BY_DATE.get(holiday.date);
  if (existing) {
    existing.push(holiday);
  } else {
    HOLIDAYS_BY_DATE.set(holiday.date, [holiday]);
  }
}
